export default __webpack_public_path__ + "static/media/Q6_1.e1b97f9a.png";